var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreVertNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-new_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m242.8,94c0-15.77-12.83-28.6-28.6-28.6s-28.6,12.83-28.6,28.6,12.83,28.6,28.6,28.6,28.6-12.83,28.6-28.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.2,
    cy: 214.6,
    r: 28.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m242.8,335.2c0-15.77-12.83-28.6-28.6-28.6s-28.6,12.83-28.6,28.6,12.83,28.6,28.6,28.6,28.6-12.83,28.6-28.6Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertNew);
export default __webpack_public_path__ + "static/media/more_vert-new.3e343d37e57132fa3935c818d84288f5.svg";
export { ForwardRef as ReactComponent };